module.exports = __webpack_public_path__ + "7e72c696f74861e349a9772186a39c3f.MP3";